import { Capacitor } from '@capacitor/core';
import { useMediaQuery } from '@mantine/hooks';
import React, { createContext, ReactNode, useMemo, useState } from 'react';

// Define the shape of your context state
export interface LayoutContextValue {
	isDesktop: boolean;
	isApp: boolean;
	debugCMS: boolean;
	cmsAlignment: 'left' | 'center' | 'right';
	cmsStyle: 'Text' | 'Warning' | 'Card';
}

// Create the context with undefined as default
// eslint-disable-next-line react-refresh/only-export-components
export const LayoutContext = createContext<LayoutContextValue | undefined>(undefined);

// Provider component props
interface LayoutContextProviderProps {
	children: ReactNode;
}

// Provider component
export const LayoutContextProvider: React.FC<LayoutContextProviderProps> = ({ children }) => {
	const isDesktop = useMediaQuery('(min-width: 1200px)');
	const isApp = useMemo(() => {
		return Capacitor.isNativePlatform();
	}, []);
	const [debugCMS] = useState(false);
	const [cmsAlignment] = useState<'left' | 'center' | 'right'>('left');
	const [cmsStyle] = useState<'Text' | 'Warning' | 'Card'>('Text');

	const contextValue = useMemo(
		() => ({ isDesktop, isApp, debugCMS, cmsAlignment, cmsStyle }),
		[isDesktop, isApp, debugCMS, cmsAlignment, cmsStyle]
	);

	return <LayoutContext.Provider value={contextValue}>{children}</LayoutContext.Provider>;
};
